module.exports = __webpack_public_path__ + "static/media/21.4e82365e.mp3";